import axios from "axios";
import * as Urls from "../constants/Urls";

export const getList = () => axios.get(Urls.KEY_RESOURCE_LIST_URL);

export const addItem = (res) => axios.post(Urls.KEY_RESOURCE_ADD_URL,res);

export const editItem = (id,res) => axios.post(Urls.keyResourceEditUrl(id),res);

